'use client';
export * from './product-card.component';
